import React from "react";
import Navbar from "../widgets/Navbar";
import Footer from "../widgets/Footer";

const HelpCenter = () => {
  return (
    <div>
      <Navbar />
        <section className="in_page p70 bg4">
              <div className="container">
                <div className="row align-items-center">
                  <div className="col-md-7">
                    <h1 className="hadding">Welcome to the Dyntech Help Center</h1>
                    <p>
                     Your comprehensive resource for guides, tutorials, and troubleshooting articles. Whether you’re a new user or an experienced pro, you’ll find everything you need to get the most out of our platforms and services.    </p>
                  </div>
                  <div className="col-md-4 m-auto">
                    <img
                      src="/img/help-center.png"
                      alt="Help Center"
                      className="img-fluid"
                    />
                  </div>
                </div>
              </div>
            </section>
            <section className="in_page p70 bg2">
              <div className="container">
                <h3 className="mb-4"><b>Getting Started</b></h3>
               
                <ul className="list mb-md-5">
                  <li>
                    <b>Account Setup & Verification: </b>  Step-by-step instructions on opening your Dyntech account and completing KYC/AML checks.
                  </li> 
                  <li>
                    <b> Funding & Withdrawals:</b> How to deposit fiat or crypto, and initiate withdrawals securely.
                  </li>
                </ul>
               <h3 className="mb-4"><b>Platform Guides</b></h3>
                 <ul className="list mb-md-5">
                  <li> <b>  Trading Platform Overview: </b> Dashboard walkthrough, order types, market data feeds. </li> 
                  <li> <b>   Copy Trading Module: </b> How to browse strategists, set parameters, and monitor performance.   </li>  
                  <li> <b> Competition Portal:  </b>  Registering for and competing in trading competitions. </li>  
                </ul>

                <h3 className="mb-4"><b>Developer Documentation</b></h3>
                 <ul className="list ">
                  <li> <b> REST & WebSocket APIs:</b>  Authentication, endpoint references, code samples. </li> 
                  <li> <b> SDKs & Sample Projects:</b> Java, Python, and JavaScript libraries to accelerate integration. </li>  
                  <li> <b> Webhook Integrations: </b>  Receive real-time trade and balance notifications. </li>  
                </ul>
 </div>
            </section>
             <section className="in_page p70 bg4">
              <div className="container">
                   <h3 className="mb-4"><b>Troubleshooting & FAQs</b></h3>
                 <ul className="list mb-md-5">
                  <li> <b>   Common Errors: </b>Authentication failures, connectivity issues, and how to resolve them. </li> 
                  <li> <b>  Performance Tips: </b>   Optimizing API calls, reducing latency, and best practices for charting tools.  </li>  
                
                </ul>

                   <h3 className="mb-4"><b>Contact Support</b></h3>
                   <p>Still need help?</p>
                 <ul className="list">
                  <li> <b> Submit a Ticket: </b>     Use the “Support” widget in your dashboard. </li> 
                  <li> <b> Email: </b>  support@dyntech.com (Typical response within 4 hours)  </li>  
                  <li> <b> Live Chat: </b>  Available 24/7 via our platform.</li>  
                </ul>
 
             
              </div>
            </section>
      <Footer />
    </div>
  );
};

export default HelpCenter;
